<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <!-- <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.about') }}
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="display-1">
            {{ $t('subMetering.about.subtitle.01')}}<br>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="text-justify">
            {{ $t('subMetering.about.text.01')}}
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="text-justify pb-0">
            <b>{{ $t('subMetering.about.subtitle.03')}}!</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('subMetering.about.text.03')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('subMetering.about.subtitle.02')}}<br>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="(item,index) in 4"
            :key="index"
            cols="12"
            class="py-1 d-flex text-justify align-center">
            <v-icon class="pl-4 pr-2">mdi-chevron-right</v-icon>
            <v-col class="py-0">
              {{ $t('subMetering.about.text.02.0' + (index + 1))}}
            </v-col>
          </v-col>
        </v-row>
        <v-row class="pt-1">
          <v-col class="text-justify">
            {{ $t('subMetering.about.text.02')}}<br>
          </v-col>
        </v-row>
        <v-row
          class="justify-center">
          <v-col
            v-for="(item,index) in links"
            :key="index"
            cols="12" sm="6" md="2"
            style="min-width:250px;">

              <v-hover
                v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 12 : 0"
                  :color="item.color"
                  dark>
                  <v-card-title>
                    {{ $t(item.title) }}
                  </v-card-title>
                  <v-card-text class="min-height-100">
                    {{ $t(item.text) }}
                  </v-card-text>
                  <v-card-actions style="justify-content: flex-end;">
                    <v-btn
                      text
                      :href="item.link"
                      target="_blank">
                      {{ $t("common.link") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'RubiconAbout',
    extends: DataComponentBase,

    data: () => ({
      links: [
        { color: "purple",  title: "subMetering.about.title.02.link.01",  text: "subMetering.about.text.02.link.01", link: "https://net.jogtar.hu/jogszabaly?docid=a2000001.mek" },
        { color: "indigo",  title: "subMetering.about.title.02.link.02",  text: "subMetering.about.text.02.link.02", link: "https://magyarkozlony.hu/dokumentumok/62d3b5895fe2aa2db665259622020d725a044840/megtekintes" },
        // { color: "indigo",  title: "subMetering.about.title.02.link.02",  text: "subMetering.about.text.02.link.02", link: "https://www.enhat.mekh.hu/valtozott-az-almerok-alkalmazasarol-szolo-mekh-rendelet" },
        { color: "blue",    title: "subMetering.about.title.02.link.03",  text: "subMetering.about.text.02.link.03", link: "https://static1.squarespace.com/static/5d63affc1ac7d1000158fdb0/t/5efb047e64897d40aa02faa7/1593508992679/almero_gyik_20200630.pdf" },
      ],
    }),

    methods: {
    },
  }
</script>
